// Fechar qualquer elemento com classe .open
$('body').on('click', e => {
  if ($('.open').length > 0) {
    $('.open').removeClass('open');
  }
});
//
// Abrir qualquer elemento com trigger
function dropdownOpen(parent, trigger, callback) {
  $(parent).on('click', e => {
    e.stopPropagation();
  });
  $(trigger).on('click', e => {
    e.preventDefault();
    if ($(parent).is('.open')) {
      $('.open').removeClass('open');
      if (callback) {
        callback();
      }
    } else {
      $('.open').removeClass('open');
      $(parent).addClass('open');
      if (callback) {
        callback();
      }
    }
  });
}
//
// Abrir esquema de horários
dropdownOpen('.tools__status-info', '.schedule__trigger');
//
// Abrir busca do header
dropdownOpen('.search', '.search__trigger', () => {
  $('.search__wrapper').addClass('search--open');
});
//
// Abrir subitens do menu
(function () {
  $('navigation__item').on('click', e => {
    e.stopPropagation();
  });
  $('.navigation__link, .navigation__button').on('click', function (e) {
    if ($(this).siblings().is('.navigation__button') || $(this).is('.navigation__button')) {
      e.preventDefault();
      if ($(this).parent().is('.open-submenu')) {
        $('.open-submenu').removeClass('open-submenu');
      } else {
        $('.open-submenu').removeClass('open-submenu');
        $(this).parent().addClass('open-submenu');
      }
    }
  });
})();
//
// Botão de limpar da busca do header
(function () {
  $('.search__clear').on('click', function (e) {
    $(this).parents('.open').removeClass('open');

    $(this).parents('.search--open').removeClass('search--open');

    $(this).siblings('.search__input').val('');
  });
})();
//
// Abrir menu responsivo
(function () {
  $('.navigation.open').on('click', e => {
    e.stopPropagation();
  });
  $('#hamburger').on('click', e => {
    e.stopPropagation();
    e.preventDefault();
    $('.navigation').addClass('open-menu');
  });
  $('.navigation__close').on('click', e => {
    $('.navigation').removeClass('open-menu');
  });
  $('.schedule__close').on('click', e => {
    $('.tools__status-info').removeClass('open');
  });
})();
//
// Abrir combo
(function () {
  $('.combo__btn').on('click', function (e) {
    e.stopPropagation();
    if ($(this).is('.open')) {
      $('.open').removeClass('open');
    } else {
      $('.open').removeClass('open');
      $(this).addClass('open');
    }
  });
  $('.combo__content').on('click', e => {
    e.stopPropagation();
  });
})();

// Resize da janela
// $(window).resize(function() {
//     setTimeout(function() {
//         $('.open').removeClass('open');
//         $('.open-menu').removeClass('open-menu');
//     }, 400);
// });
